import {createReducer} from '../../../utilities';
import {
  REQUEST_FETCH_STATS_TOURNAMENTS,
  SUCCESS_FETCH_STATS_TOURNAMENTS,
  FAIL_FETCH_STATS_TOURNAMENTS,
} from '../../../../actions/entities/statistics/tournaments';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  const {data} = action;
  return {
    ...state,
    data,
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_FETCH_STATS_TOURNAMENTS]: requestFetch,
  [SUCCESS_FETCH_STATS_TOURNAMENTS]: successFetch,
  [FAIL_FETCH_STATS_TOURNAMENTS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/tournaments/creations.js